import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as appConstants from "../../../constants/index";
import { Chips } from "primereact/chips";
import explore from "../../../assets/payment/explore.svg";
import offerRight from "../../../assets/payment/offer-right-arrow.svg";
import arrowgrey from "../../../assets/payment/arrow-grey.svg";
import cred from "../../../assets/payment/cred.png";
import upi from "../../../assets/payment/UPI.svg";
import paytm from "../../../assets/payment/paytm-u.png";
import Samsungwallet from "../../../assets/payment/sumsunagwallet.png"
import { ProceedButton } from "../../common/login/loginTags";
import { useNavigate } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { InputText } from "primereact/inputtext";
import { setRetryPayment } from "src/services/CouponPayment";
import { hitGa } from "src/services/PassportServices";


const Upi = (props) => {
  const [value, setValue] = useState([]);

  const formRef = useRef(null);
  const theme = localStorage.getItem('theme');
  const bookingid = localStorage.getItem("bookingid");
  const loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  const subscription = localStorage.getItem('subscription')
  const [value6, setValue6] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const [errorMsg, setErrorMsg] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    //getNetBankingList1();
    // console.log(props);
    initJuspay();
    console.log(subscription);
  }, []);

  const initJuspay = async () => {
    // console.log('working');
    var juspay_form = Juspay.Setup({
      payment_form: "#payment_form_upi",
      success_handler: function (status) {
        console.log(status);
      },
      error_handler: function (error_code, error_message, bank_error_code, bank_error_message, gateway_id) {
        console.log('error', error_code, error_message);
        setErrorMsg("Facing some challange: "+ error_message);
        setShowAlert(true);
        setLoading(false);
      },
    })
  }
  const getverifyVpa = async () => {
    if (!value6) {
      setErrorMsg("Please enter vpa!");
      setShowAlert(true);
      return '';
    }
    console.log(subscription);
    setLoading(true);
    const postData = {
      "bookingId": localStorage.getItem("bookingid"),
      "key": value6,
      "mandate": subscription == "true"?true:false
    };
    await axios
      .post(`${appConstants.base_url}v1/payment/juspay/vpa`, postData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""
            }`,
          chain: theme === "inoxTheme" ? "INOX" : "PVR",
          city: localStorage.getItem("city"),
          appVersion: appConstants.av,
          platform: appConstants.pt,
          country: appConstants.cname,
        },
      })
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          let output = dt.output;
          if(subscription == "true" && output.mandate == "false"){
            setLoading(false);
            setErrorMsg("UPI is not valid for subscription");
            setShowAlert(true);
          }
          else if(output.valid == "true"){
            gethmac();
          }
          console.log('working');
          
        } else {
          setErrorMsg(res.data.msg);
          setShowAlert(true);
          console.log(res.data.msg);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  }
  const gethmac = async () => {
    if (!value6) {
      setErrorMsg("Please enter vpa!");
      setShowAlert(true);
      return '';
    }
    setLoading(true);
    const postData = {
      "transId": localStorage.getItem("transid"),
      "bookingId": localStorage.getItem("bookingid"),
      "bookType": localStorage.getItem("booking_type"),
      "paytype": "UPI",
      "pgtype": "JUSPAY",
      "mandate": subscription == "true"?true:false,
      "dtmSource": "PVRINOX"
    };

    await axios
      .post(`${appConstants.base_url}v1/payment/juspay/hmac`, postData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""
            }`,
          chain: theme === "inoxTheme" ? "INOX" : "PVR",
          city: localStorage.getItem("city"),
          appVersion: appConstants.av,
          platform: appConstants.pt,
          country: appConstants.cname,
        },
      })
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          localStorage.setItem('pgused','UPI');
          setRetryPayment(props.payMode, "retry-UPI"+localStorage.getItem("bookingid"));
          const url = window.location.href;

          localStorage.setItem("cinema_name",url.split('/').pop().replaceAll('%20',' '));
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_payment_info',
            ecommerce: {
              currency: 'rupees',
              items: [{
                affiliation: 'UPI',                   //(payment type)                                                
                item_name: localStorage.getItem('movie_name'),                            // (ticket's name,passport's name,gift card's name)
                item_id: localStorage.getItem('movieid'),                             //(ticket's id,passport's id,gift card's id)
                price: res.data.output.amount,
                value: res.data.output.amount,                                 //(total amount)
                //(total amount)
                item_brand: appConstants.cinemaChain,                       // (pvr/inox)
                item_category: 'ticket,f&b',                       //(selected ticket, gift card & passport)
                item_category2: localStorage.getItem('city') + "/" + localStorage.getItem('cinema_name'),
                item_category3: localStorage.getItem('selecteddate')+","+localStorage.getItem('selectedseats'),                      //( selected date & seat number)
                item_category4: localStorage.getItem('genre'),                     //(language &  genre)
                item_variant: localStorage.getItem('format'),                      //( selected format)   
                quantity: localStorage.getItem('quantity')


              }]
            }
          });
          hitGa({
            'event': 'add_payment_info',
            'item_category' : 'Passport', 
            'passport_payment_type' : 'UPI',
            'passport_amount' : res.data.output.amount
            })
          // setTicketSummary(ndt);
          //document.getElementById("payment_form_NB").submit();
          localStorage.setItem("paymentid", dt.output.paymentId);
          localStorage.setItem("payment_type", "nonwallet");
          console.log("bankList==>", dt);
          formRef.current.click();
        } else {
          console.log(res.data.msg);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  }
  return (
    <>
      <SweetAlert
        error
        show={showAlert}
        title={errorMsg}
        onConfirm={() => {
          setShowAlert(false);
          setLoading(false);
          // console.log('confirm')
          //navigate('/')
        }}
        onCancel={() => {setShowAlert(false);setLoading(false);}}
        confirmBtnCssClass={theme === 'inoxTheme' ? 'confirm-btn-inox border-0' : 'confirm-btn-pvr border-0'}
      >
        {errorMsg}
      </SweetAlert>
      <div className="">
        <div className="payment-form">
          <div className="paywithdebit">
            <div className="debit-card show-in-desktop-view">
              <h6>UPI</h6>
            </div>
            <div className="to-paid">
              {/* <p>
                To be Paid:
                <span className="price-cross">₹8888</span>{" "}
                <span className="price-blod">₹8888</span>
              </p> */}
            </div>
          </div>
          <div className="payment-netbanking">
            <div className="upi-flow">
              <form class="juspay_inline_form" id="payment_form_upi">
                <InputText type="hidden" class="merchant_id" value={props.juspayinit ? props.juspayinit.merchant_id : ''} />
                <InputText type="hidden" class="order_id" value={bookingid} />
                {/* <InputText type="hidden" className="should_create_mandate" value="true" /> */}
                {subscription == "true"?
                  <>
                    <InputText style={{ "display": "none" }} type="checkbox" className="should_create_mandate" checked={subscription} value={subscription} />
                    <InputText type="hidden" className="mandate_type" value="EMANDATE" />
                  </>
                :""}
                {/* <div className="upi-feilds">
                  <div className="p-fluid">
                    <span className="p-float-label">
                      <InputText
                        id="upi"
                        className="form-control upi_vpa"
                        value={value6}
                        onChange={(e) => {
                          setValue6(e.target.value)
                          // setValue(e.value);
                          // console.log('value', e.value)
                        }} />
                      <label htmlFor="upi">UPI ID</label>
                    </span>
                  </div>
                </div> */}
                <div className="col-md-12 my-3">
                  <div className="payment-feild">
                    <span className="p-float-label">
                    <InputText 
                    type="text" 
                    id="upi" 
                    className="offer-control upi_vpa" 
                    value={value6}
                    onChange={(e) => setValue6(e.target.value)} 
                    />
                    <label htmlFor="upi">UPI ID</label>
                    </span>
                  </div>
                  {props?.promotionText?
                    <p className="my-3" dangerouslySetInnerHTML={{ __html: props?.promotionText }}></p>
                  :""}
                </div>
                <div className="register-btn">
                  <ProceedButton
                    className={value6 && !loading? 'btn-proceeds' : "btn-proceeds btn-opacity"}
                    type="button"
                    onClick={() => {
                      getverifyVpa()
                      //navigate('/final-ticket')
                      // console.log("Button Clicked")
                    }}
                  >
                    Verify & Pay
                    {loading ? (
                            <i
                              className="pi pi-spin pi-spinner"
                              style={{ fontSize: "1.5em" }}
                            ></i>
                          ) : (
                            ""
                          )}
                  </ProceedButton>
                  <button ref={formRef} type="submit" style={{ "display": "none" }}>
                    Pay
                  </button>
                </div>
                <div className="upi-collect">
                {/* {props?.promotionText?
                  <p dangerouslySetInnerHTML={{ __html: props?.promotionText }}></p>
                :""} */}
                  <p>A collect request notification will be sent to this UPI ID</p>
                </div>
                <InputText type="hidden" class="payment_method_type" value="UPI" />
                <InputText type="hidden" class="payment_method" value={subscription == "true"?"COLLECT":"UPI"} />
                <InputText type="hidden" class="txn_type" value="UPI_COLLECT" />
                <InputText type="hidden" class="redirect" value="true" />
                <InputText type="hidden" class="payment_channel" value="WEB" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Upi